export const API_URL = 'https://api.cafe-hamlet.fr';
export const MEDUSA_URL = 'http://localhost:9000';

export const TOKEN_KEY = 'strapi-jwt-token';
